import { useEffect } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSchemaProps {
  faqs: FAQItem[];
}

export function FAQSchema({ faqs }: FAQSchemaProps) {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    };

    // Remove any existing FAQ schema to prevent duplicates
    document.querySelectorAll('script[data-seo="faq"]').forEach((el) => el.remove());

    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-seo", "faq");
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);

    return () => {
      s.remove();
    };
  }, [faqs]);

  return null;
}
